import PropTypes from 'prop-types'
import React from 'react'
import { connect as connectRedux } from 'react-redux'
import Link from 'components/Link'
import { getAuthIsLoggedIn } from 'services/auth'

export const TYPE_TEAL = 'teal'
export const TYPE_BLUE_DARK = 'blue-dark'
export const TYPE_WHITE = 'white'
export const TYPE_WHITE_PLUS = 'white-plus'
export const TYPE_BLACK = 'black'
export const TYPE_ROYAL_PLUS = 'royal-plus'

function getClassName (props) {
  const { className = [], inline } = props
  const inlineClass = inline ? 'gaia-logo__inline' : ''
  const logoClass = `gaia-logo--${props.type}`
  return ['gaia-logo', logoClass, inlineClass].concat(className).join(' ')
}

function GaiaLogo (props) {
  const className = getClassName(props)
  const {
    auth, isHref = false, onClick, inline = false,
  } = props
  const isLoggedIn = getAuthIsLoggedIn(auth)

  if (isHref) {
    /**
     * if the user is not logged in, we need to refresh the page to redirect to the WP homepage
     */
    return (
      <Link
        className={className}
        to="/"
        onClick={onClick}
        directLink={isLoggedIn ? false : true} // eslint-disable-line
      >
        <span className="assistive">Gaia</span>
      </Link>
    )
  }

  if (inline) {
    return <span className={className} />
  }

  return <div className={className} />
}

GaiaLogo.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.array,
  onClick: PropTypes.func,
  inline: PropTypes.bool,
  isHref: PropTypes.bool,
}

export default connectRedux(
  (state) => ({
    auth: state.auth,
  }),
)(GaiaLogo)
